<template>
  <div class="svg-zoomer">
    <div v-if="loading || loadingTypes" class="loader-svg">
      <Loader></Loader>
    </div>
    <div id="svgEmbed"></div>
  </div>
</template>
<script>
import $ from 'jquery';
// import svgPanZoom from '../utils/svg-pan-zoom';

export default {
  props: {
    svgUrl: {
      type: String,
      default: '',
    },
    blockId: {
      type: String,
      default: '',
    },
    types: {
      type: Array,
      default() {
        return [];
      },
    },
    loadingTypes: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      loading: false,
      blockEl: null,
    };
  },
  created() {
    if (this.svgUrl) {
      this.init(() => {});
    }
  },
  watch: {
    blockId: {
      handler(id) {
        $('.svg-block').removeAttr('data-toggle', true);
        $(`#${id}`).attr('data-toggle', true);
      },
      inmediate: true,
    },
  },
  methods: {
    getSvg(cb) {
      this.loading = true;
      $.get(
        this.svgUrl,
        { Origin: 'jn-v2' },
        (svg) => {
          $('#svgEmbed').html(svg);
          this.loading = false;
          cb();
        },
        'text',
      );
    },
    init(cb) {
      this.getSvg(() => {
        this.blockEl = $('.svg-block');
        // svgPanZoom('#svgZoom');
        this.clickBlock();
        this.disableBlocks();
        cb();
      });
    },
    clickBlock() {
      this.blockEl.unbind('click');
      this.blockEl.on('click', (event) => {
        const {
          id,
          dataset: { disabled },
        } = event.currentTarget;
        if (disabled) return;
        this.$emit('select', { id });
      });
    },
    disableBlocks() {
      $('.svg-block').attr('data-disabled', true);
      this.types.forEach((el) => {
        if (el.stock) {
          $(`#${el.blockId}`).removeAttr('data-disabled');
        }
      });
    },
  },
};
</script>

<style lang="scss">
.svg-zoomer {
  height: 65vh;
  padding: 0;
  background: #fff;
  position: relative;
  svg{
    width: 100%;
    height: 65vh;
  }
}
.loader-svg{
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(#fff, 0.5);
}
.svg-block{
  cursor: pointer;
  // opacity: 0.8;
  &[data-disabled] {
    cursor: default;
    > path:first-child,
    > rect {
      fill: #999;
    }
  }
  &[data-toggle] {
    opacity: 1 !important;
  }
}
</style>
